import { useRegisterSW } from 'virtual:pwa-register/react';
import { Snackbar, Alert, Button } from '@mui/material';

// Surfaces the two states vite-plugin-pwa exposes: a fresh install becoming
// offline-ready, and a new build being available. The hook itself is a no-op
// when no service worker is registered (Capacitor builds, dev mode), so this
// component is safe to mount unconditionally.
export default function PwaUpdatePrompt() {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      console.error('Service worker registration error:', error);
    },
  });

  const closeOfflineReady = () => {
    setOfflineReady(false);
  };
  const closeNeedRefresh = () => {
    setNeedRefresh(false);
  };

  return (
    <>
      <Snackbar
        open={offlineReady}
        autoHideDuration={4000}
        onClose={closeOfflineReady}
      >
        <Alert
          severity="success"
          onClose={closeOfflineReady}
          sx={{ width: '100%' }}
        >
          App is ready to work offline.
        </Alert>
      </Snackbar>

      <Snackbar
        open={needRefresh}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          severity="info"
          sx={{ width: '100%' }}
          action={
            <>
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  void updateServiceWorker(true);
                }}
              >
                Refresh
              </Button>
              <Button color="inherit" size="small" onClick={closeNeedRefresh}>
                Later
              </Button>
            </>
          }
        >
          A new version is available.
        </Alert>
      </Snackbar>
    </>
  );
}
